// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"1bcea968","243":"636953a1","264":"741d530b","357":"06d3c376","389":"611c559e","453":"3e15a7d2","477":"0e045740","488":"7f5e1db5","558":"c48c050a","673":"f5cf0e5b","696":"9617e23b"}[chunkId] + ".chunk.js";
};